import * as S from './styles'
import React from 'react'

interface TitleProps {
  children: React.ReactNode
}

export const Title = ({ children }: TitleProps) => {
  return <S.Title>{children}</S.Title>
}
